require('../modules/es6.object.to-string');
require('../modules/es6.array.iterator');
require('../modules/es6.weak-map');
module.exports = require('../modules/_core').WeakMap;


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/es6/weak-map.js
 ** module id = 363
 ** module chunks = 1
 **/